import { render, staticRenderFns } from "./ArticleListPage.vue?vue&type=template&id=626be906&scoped=true"
import script from "./ArticleListPage.vue?vue&type=script&lang=js"
export * from "./ArticleListPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleListPage.vue?vue&type=style&index=0&id=626be906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626be906",
  null
  
)

export default component.exports